module.exports = __webpack_public_path__ + "static/partner-c80922841aae16a35f4d043366df9894.png";